import { AxiosPromise } from 'axios';
import { IChangeSitePasswordCommand } from './types';
import { instance } from '../../../../services';

const changeSitePassword = (data: IChangeSitePasswordCommand): AxiosPromise => {
  const { pin } = data;

  return instance.put(`api/sites/${pin}/password`, data);
};

export default changeSitePassword;
